import React, { CSSProperties } from "react";
import {
  ElementFactory,
  QuestionDropdownModel as _QuestionDropdownModel,
  Serializer,
  settings,
  surveyLocalization, // PHKL Custom
} from "survey-core";
import {
  SurveyQuestionDropdown as _SurveyQuestionDropdown,
  ReactElementFactory,
  SurveyElementBase,
  SurveyQuestionDropdownBase,
} from "survey-react-ui";
// mui start
import { ThemeProvider, createTheme, Button } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormControl from "@mui/material/FormControl";
// mui end
import * as style from "../survey/common.style";
import { CustomType } from "../survey/survey.util";
import "./index.css";
import { dropdownStyles } from "./dropdown.style";
import { ChevronRight } from "@mui/icons-material";
import { FullModalList, ModalData } from "./full-modal";
import { useGlobalModal } from "../../../../../components/use-modal/use-modal";
import { isMobile } from "../../../../../utils/common-utils";
import { IconFont } from "../../../../../icon-font/iconfont";
import { color } from "../../../../../mui-theme/palette";
import { getI18n } from "react-i18next";
import { textStyleSet } from "../../../../../mui-theme/text.style";
import { t } from "i18next"; // PHKL Custom

const CUSTOM_TYPE = CustomType.Dropdown;
// const CUSTOM_TYPE = "dropdown2";
type ModalConfig = {
  modalTitle?: string;
  fullScreen?: boolean;
  showSearch?: boolean;
};

export class QuestionDropdownModel extends _QuestionDropdownModel {
  getType() {
    return CUSTOM_TYPE;
  }
  get modalConfig(): ModalConfig {
    return this.getPropertyValue("modalConfig");
  }
  set modalConfig(val: ModalConfig) {
    this.setPropertyValue("modalConfig", val);
  }
}

// Add question type metadata for further serialization into JSON
export const initDropdownSerializer = () => {
  Serializer.addClass(
    CUSTOM_TYPE,
    [
      {
        name: "placeholder",
        default: "Please select",
      },
      {
        name: "searchEnabled",
        default: false,
      },
      {
        name: "allowClear",
        default: true,
      },
      {
        name: "modalConfig",
        default: {},
      },
      {
        name: "choicesLazyLoadByUrl",
        default: {},
      },
      { name: "allowClear:boolean", alternativeName: "showOptionsCaption", default: true },
      { name: "choicesMin:number", default: 0 },
      { name: "choicesMax:number", default: 0 },
      { name: "choicesStep:number", default: 1, minValue: 1 },
      {
        name: "autocomplete",
        alternativeName: "autoComplete",
        choices: settings.questions.dataList,
      },
      { name: "textWrapEnabled:boolean", default: true },
      { name: "renderAs", default: "default", visible: false },
      { name: "searchEnabled:boolean", default: true, visible: false },
      { name: "searchMode", default: "contains", choices: ["contains", "startsWith"] },
      { name: "choicesLazyLoadEnabled:boolean", default: false, visible: false },
      { name: "choicesLazyLoadPageSize:number", default: 25, visible: false },
      { name: "inputFieldComponent", visible: false },
      { name: "itemComponent", visible: false, default: "" },
    ],
    function () {
      return new QuestionDropdownModel("");
    },
    "selectbase",
  );
};

const theme = createTheme({});

ElementFactory.Instance.registerElement(CUSTOM_TYPE, (name) => {
  return new QuestionDropdownModel(name);
});
class ExamScheduleOption extends SurveyElementBase<any, any> {
  handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const jsonObj = this.props.item.jsonObj;
    const disabled = jsonObj?.disabled;
    if (disabled) {
      event.stopPropagation();
    }
  };
  renderElement() {
    const question = this.props.question;
    const item = this.props.item;
    const jsonObj = item?.jsonObj;
    const disabled = jsonObj?.disabled;
    const isLastIndex = jsonObj?.isLastIndex; // PHKL Custom

    return (
      <div
        className={`custom-dropdown-item ${disabled ? "text-grey99" : ""}`}
        onClick={this.handleClick}
        style={{ borderBottomWidth: isLastIndex ? 0 : 1, borderBottomColor: "#E6E6E6" }} // PHKL Custom
      >
        <div>{item?.text}</div>
        <div>{jsonObj?.underText}</div> {/* PHKL Custom */}
        {jsonObj?.examMode ? (
          <div className="flex flex-row">
            <IconFont name={jsonObj.examModeIcon} size={16} />
            <span style={textStyleSet.text_14_med} className="pl-2">
              {getI18n().t(`Common.${jsonObj.examMode}`)}
            </span>
          </div>
        ) : null}
        {/* PHKL Custom -s
        {jsonObj?.deviceType ? (
          <div className="flex flex-row pt-1" style={textStyleSet.text_14_med}>
            <span>{getI18n().t("Device")}: </span>
            <span className="pl-2">{jsonObj.deviceType}</span>
          </div>
        ) : null}
          PHKL Custom -e*/}
      </div>
    );
  }
}
ReactElementFactory.Instance.registerElement("exam-schedule-item", (props) => {
  return React.createElement(ExamScheduleOption, props);
});
// A class that renders questions of the new type in the UI
export class SurveyQuestionDropdown extends SurveyQuestionDropdownBase<QuestionDropdownModel> {
  modal: any;
  constructor(props: any) {
    super(props);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    this.modal = useGlobalModal();
    this.state = {
      value: this.question.value,
      options: this.getChoices(),
      openModal: false,
    };
  }

  getChoices() {
    const arr = this.question.choices ?? [];
    const arrOption = arr.map((item: any) => {
      if (typeof item === "string") {
        return {
          key: item,
          label: item,
          value: item,
        };
      }
      return {
        key: item.value,
        label: item.text,
        value: item.value,
      };
    });
    return arrOption;
  }
  // get question() {
  //   let isModuleReadOnly = false;

  //   if (this.questionBase.survey) {
  //     const activePage: any = this.questionBase.survey.currentPage;
  //     if (activePage) {
  //       isModuleReadOnly = activePage.readOnly;
  //     }
  //   }

  //   this.questionBase.readOnly = this.questionBase.readOnly || isModuleReadOnly;
  //   return this.questionBase;
  // }
  get value() {
    return this.question.value;
  }
  get placeholder() {
    return this.question.placeholder;
  }
  get modalConfig(): ModalConfig {
    return this.question.modalConfig;
  }
  onAutoCompleteChange(event: any, value: any | null) {
    this.question.value = event.target.value;
  }

  onModalChange(v: ModalData) {
    this.question.value = v.value;
  }

  // Support read-only
  get style() {
    return (
      this.question.getPropertyValue("readOnly") ? { pointerEvents: "none" } : undefined
    ) as CSSProperties;
  }

  renderIcon() {
    return <ChevronRight />;
  }
  onCloseModal() {
    this.modal.close();
  }
  onOpenModal() {
    // judge current device is mobile or not
    const _isMobile = isMobile();

    const fullScreen = this.modalConfig?.fullScreen ?? _isMobile;
    const modalContent = (
      <div
        className={
          fullScreen
            ? "h-screen w-screen bg-white flex"
            : `bg-white rounded-2xl ${this.modalConfig?.showSearch ? "h-[calc(100vh-64px)]" : ""}`
        }
      >
        <FullModalList
          data={this.state.options}
          showClose
          selected={this.question.value}
          showSearch={this.modalConfig?.showSearch}
          onClose={this.onCloseModal.bind(this)}
          onChange={this.onModalChange.bind(this)}
          header={this.modalConfig?.modalTitle}
        ></FullModalList>
      </div>
    );

    const modalProps = fullScreen
      ? {
          showHeader: false,
          modalType: "bottom",
          modalProps: {
            className: "dialog-full",
            PaperProps: {
              style: {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                width: window.innerWidth + "px",
              },
            },
          },
        }
      : {
          showHeader: false,
        };

    this.modal.open(modalContent, modalProps);
  }
  renderModalScreen() {
    return (
      <ThemeProvider theme={theme}>
        <div style={this.style}>
          <FormControl fullWidth sx={style.formControl} variant="standard">
            <Button
              id={this.question.name}
              disabled={this.question.readOnly}
              style={
                this.question.readOnly
                  ? dropdownStyles.fullModalDisabledBtn
                  : dropdownStyles.fullModalBtn
              } //PHKL Custom
              onClick={this.onOpenModal.bind(this)}
              endIcon={<ExpandMoreIcon />}
            >
              {this.question.value ?? ""}
            </Button>
          </FormControl>
        </div>
      </ThemeProvider>
    );
  }

  renderElement() {
    // PHKL Custom -s
    surveyLocalization.locales["zh-tw"].filterStringPlaceholder = t("Common.search_placeholder");
    surveyLocalization.locales["zh-tw"].modalCancelButtonText = t("app.button.cancel");
    surveyLocalization.locales["en"].filterStringPlaceholder = t("Common.search_placeholder");
    surveyLocalization.locales["en"].modalCancelButtonText = t("app.button.cancel");
    // PHKL Custom -e

    if (this.modalConfig) return this.renderModalScreen();
    return <_SurveyQuestionDropdown {...this.props} />;
  }
}
